// Single source for the CSP nonce. The value is baked into the `csp-nonce` meta
// tag at build time (see inject-csp-nonce.js) and mirrored into the served CSP
// header, so nonce'd <style> elements pass style-src without 'unsafe-inline'.
export const CSP_NONCE =
  (typeof document !== 'undefined' &&
    document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content')) ||
  '';
